export default {
  header: "Your Order",
  view: "Order"
};
